/*
 * Fills {ship_date}, {delivery_from}, {delivery_to} in [data-pdp-delivery-text]
 * elements. Dates are computed in the shopper's browser time zone; settings come
 * from the nearest .pdp's [data-pdp-delivery-config] (the Delivery estimate block).
 */
(() => {
  const DEFAULTS = { processing: 3, transitMin: 4, transitMax: 7, skipWeekends: true, dateFormat: 'short' };

  const isWeekend = (date) => date.getDay() === 0 || date.getDay() === 6;

  const addBusinessDays = (start, days, skipWeekends) => {
    const date = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    let added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (!skipWeekends || !isWeekend(date)) added++;
    }
    return date;
  };

  const readConfig = (root) => {
    const el = root?.querySelector('[data-pdp-delivery-config]');
    if (!el) return DEFAULTS;
    const num = (value, fallback) => (Number.isFinite(parseInt(value, 10)) ? parseInt(value, 10) : fallback);
    return {
      processing: num(el.dataset.processing, DEFAULTS.processing),
      transitMin: num(el.dataset.transitMin, DEFAULTS.transitMin),
      transitMax: num(el.dataset.transitMax, DEFAULTS.transitMax),
      skipWeekends: el.dataset.skipWeekends !== 'false',
      dateFormat: el.dataset.dateFormat || DEFAULTS.dateFormat,
    };
  };

  const render = (root) => {
    const config = readConfig(root);
    const locale = document.documentElement.lang || undefined;
    const formatOptions =
      config.dateFormat === 'weekday'
        ? { weekday: 'short', month: 'short', day: 'numeric' }
        : { month: 'short', day: 'numeric' };
    const format = (date) => new Intl.DateTimeFormat(locale, formatOptions).format(date);

    const ship = addBusinessDays(new Date(), config.processing, config.skipWeekends);
    const tokens = {
      ship_date: format(ship),
      delivery_from: format(addBusinessDays(ship, config.transitMin, config.skipWeekends)),
      delivery_to: format(addBusinessDays(ship, Math.max(config.transitMin, config.transitMax), config.skipWeekends)),
    };

    root.querySelectorAll('[data-pdp-delivery-text]').forEach((el) => {
      const template = el.dataset.template || '';
      el.textContent = template.replace(/\{(ship_date|delivery_from|delivery_to)\}/g, (_, key) => tokens[key]);
      el.hidden = false;
    });
  };

  const init = () => document.querySelectorAll('.pdp').forEach(render);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
